import Config from './Config'

export default function withConfig(Component) {
  const ConfigHoc = props => <Config>{config => <Component config={config} {...props} />}</Config>
  return ConfigHoc
}
